import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/image/logo.png";
import "../styles/Menu.css";

function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const [isLangOpen, setIsLangOpen] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('lang', i18n.language);
  }, [i18n, i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangOpen(false);
  };

  const isActive = (path) => {
    if (path === '/') return pathname === '/';
    return pathname.startsWith(path);
  };

  return (
    <header className={`menu-header ${pathname !== '/' ? 'not-home' : ''}`}>
      <div className="nav-tire"></div>

      <nav className="navbar">
        <div className="nav-left">
          <Link to="/" className="navbar-logo-link">
            <img src={logo} alt="TIWIZI Logo" className="navbar-logo" />
          </Link>
          <div className="navbar-slogan">
            <span>{t('menu.slogan1')}</span>
            <span>{t('menu.slogan2')}</span>
          </div>
        </div>

        <button className="mobile-menu-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "✕" : "☰"}
        </button>

        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li className={isActive('/') ? 'active' : ''}><Link to="/" onClick={() => setIsOpen(false)}>{t('menu.home')}</Link></li>
          <li className={isActive('/about') ? 'active' : ''}><Link to="/about" onClick={() => setIsOpen(false)}>{t('menu.about')}</Link></li>
          <li className={isActive('/projets') ? 'active' : ''}><Link to="/projets" onClick={() => setIsOpen(false)}>{t('menu.projects')}</Link></li>
          <li className={isActive('/activites') ? 'active' : ''}><Link to="/activites" onClick={() => setIsOpen(false)}>{t('menu.activities')}</Link></li>
          <li className={isActive('/partners') ? 'active' : ''}><Link to="/partners" onClick={() => setIsOpen(false)}>{t('menu.partners')}</Link></li>
          <li className={isActive('/reservation') ? 'active' : ''}><Link to="/reservation" onClick={() => setIsOpen(false)}>{t('menu.reservation')}</Link></li>
          <li className={isActive('/contact') ? 'active' : ''}><Link to="/contact" onClick={() => setIsOpen(false)}>{t('menu.contact')}</Link></li>
        </ul>

        <div className="nav-right">
          <div className="nav-actions">
            <div className="lang-switcher-container">
              <button className="action-btn" title="Langue" onClick={() => setIsLangOpen(!isLangOpen)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
              </button>
              {isLangOpen && (
                <div
                  className="lang-dropdown"
                  style={
                    i18n.dir() === 'rtl'
                      ? { right: 'auto', left: 0 }
                      : { right: 0, left: 'auto' }
                  }
                >
                  <button className={i18n.language === 'fr' ? 'active' : ''} onClick={() => changeLanguage('fr')}>Français</button>
                  <button className={i18n.language === 'en' ? 'active' : ''} onClick={() => changeLanguage('en')}>English</button>
                  <button className={i18n.language === 'ar' ? 'active' : ''} onClick={() => changeLanguage('ar')}>عربي</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Menu;
